export default "<canvas id=\"barcode\" class=\"bar-code\"></canvas>\r\n";